define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"dijit/Dialog",
	"dijit/popup",
	"dijit/TooltipDialog",
	"./_DialogMixin"
], function(declare,lang,aspect,Dialog,popup,TooltipDialog,_DialogMixin) {

	var DialogLevelManager = Dialog._DialogLevelManager;

	return declare([TooltipDialog, _DialogMixin], {

		postCreate: function(){
			this.inherited(arguments);

			aspect.after(this, "onSave", lang.hitch(this, "hide"), true);
			aspect.after(this, "onCancel", lang.hitch(this, "hide"), true);
		},

		show: function(/*__OpenArgs*/ args) {
			// summary: open popup with this dialog as a popup widget. Arguments are the same as in popup.open
			args = lang.mixin({popup: this}, args);
			popup.open(args);
		},

		hide: function() {
			// summary: close popup
			popup.close(this);
		},

		onOpen: function() {
			// summary: called from popup.open. Shows DialogUnderlay under this dialog
			DialogLevelManager.show(this, {"class":"csi-underlay-transparent"});
		},

		onClose: function() {
			// summary: called from popup.close. Hides DialogUnderlay under this dialog
			this.onHide();
			DialogLevelManager.hide(this);
		}
	});
});